import React from "react";
import { Chip } from "@mui/material";
import { isDepartedMember, memberFullName } from "./helper";

// Shared option row for every member picker. Departed members stay selectable
// so closed business can be attributed to whoever actually referred it, but
// they are marked so they are never mistaken for a current member.
const renderMemberOption = (props, option, { selected }) => (
  <li
    {...props}
    style={{
      backgroundColor: selected ? "#EAF2FF" : undefined,
      fontSize: "14px",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "8px",
    }}
  >
    {memberFullName(option)}
    {isDepartedMember(option) && (
      <Chip
        label="Departed"
        size="small"
        variant="outlined"
        sx={{
          height: "20px",
          fontSize: "11px",
          color: "#6B7280",
          borderColor: "#D1D5DB",
        }}
      />
    )}
  </li>
);

export default renderMemberOption;
